{
    "cobal": {
        "server": "https://webomat.unistra.fr",
        "id": 277
    }
}
